import { Expression } from './Expression';

export const ExpressionEndOfInput: Expression = {
  id: 'end of input',
  parse: null
};



// WEBPACK FOOTER //
// ./src/magicbox/Expression/ExpressionEndOfInput.ts